export const ageMethod = "age nearest";
export const gateway = "https://mitch-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/mitch";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJtaXRjaCIsIm5hbWUiOiJtaXRjaCIsImlhdCI6MTc3OTkyNDk1OCwiZXhwIjoxOTM3NzEyOTU4fQ.JZ_l4fc96hYAKaXO3u5o9Gq19RurT0mVMvSWmEC56Lg";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"mitch.link.wawanesalife.com": {
		a: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_mitch",
			brands: [
				"mitch.link.wawanesalife.com",
			],
			broker: "mitch",
			broker_formatted_name: "Mitch Insurance",
			email: "info@mitchinsurance.com",
			environment: "stable",
			environment_id: "stable",
			g4: "G-2QM64W4BM4",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"1555 Wentworth St. Unit 200, Whitby",
				"Whitby",
				"ON",
				"L1N 9T6",
			],
			map2: [
				"110 Yonge St. Suite 403",
				"Toronto",
				"ON",
				"M5C 1T4",
			],
			map3: "hide",
			map4: "hide",
			"maps": {
				"map2": [
					"110 Yonge St. Suite 403",
					"Toronto",
					"ON",
					"M5C 1T4",
				],
				"map1": [
					"1555 Wentworth St. Unit 200, Whitby",
					"Whitby",
					"ON",
					"L1N 9T6",
				],
			},
			menuPhone: "button",
			phone: "1-800-731-2228",
			photo1: "show",
			photo2: "show",
			photo3: "show",
			photo4: "show",
			photos: [
				"carousel1.jpg",
				"carousel2.jpg",
				"carousel3.jpg",
				"carousel4.jpg",
				"carousel5.jpg",
			],
			privacyLink: "https://mitchinsurance.com/privacy-policy/",
			tagline: "Say hi to lovable insurance!",
			tcLink: "https://mitchinsurance.com/terms-conditions/",
			themeSwitcher: "hide",
			website: "https://mitchinsurance.com",
			scope: "mitch#branding#mitch.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "mitch.link.wawanesalife.com",
		},
		b: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_mitch",
			brands: [
				"mitch.link.wawanesalife.com",
			],
			broker: "mitch",
			broker_formatted_name: "Mitch Insurance",
			email: "info@mitchinsurance.com",
			environment: "stable",
			environment_id: "stable",
			g4: "G-2QM64W4BM4",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"1555 Wentworth St. Unit 200, Whitby",
				"Whitby",
				"ON",
				"L1N 9T6",
			],
			map2: [
				"110 Yonge St. Suite 403",
				"Toronto",
				"ON",
				"M5C 1T4",
			],
			map3: "hide",
			map4: "hide",
			"maps": {
				"map2": [
					"110 Yonge St. Suite 403",
					"Toronto",
					"ON",
					"M5C 1T4",
				],
				"map1": [
					"1555 Wentworth St. Unit 200, Whitby",
					"Whitby",
					"ON",
					"L1N 9T6",
				],
			},
			menuPhone: "button",
			phone: "1-800-731-2228",
			photo1: "show",
			photo2: "show",
			photo3: "show",
			photo4: "show",
			photos: [
				"carousel1.jpg",
				"carousel2.jpg",
				"carousel3.jpg",
				"carousel4.jpg",
				"carousel5.jpg",
			],
			privacyLink: "https://mitchinsurance.com/privacy-policy/",
			tagline: "Say hi to lovable insurance!",
			tcLink: "https://mitchinsurance.com/terms-conditions/",
			themeSwitcher: "hide",
			website: "https://mitchinsurance.com",
			scope: "mitch#branding#mitch.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "mitch.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 18:35:58 GMT-0500 (Central Daylight Time)
